import { gql } from '@apollo/client';

const loginEdbaAdminQuery = gql`
    mutation ($credential: LoginUserInput!){
        login(credential: $credential)
    }
`;


export { loginEdbaAdminQuery };